// PRD-826 stub for the cross-spec dep TRIB-B-STREAM-INTEGRATE.
// Real implementation will subscribe to a server-sent-events / websocket stream
// for push-run status. This stub returns a stable no-op so the wizard and run
// history surface render without a hard dependency.
// TODO(PRD-826/TRIB-B-STREAM-INTEGRATE): replace with live SSE subscription.

import { useEffect, useState } from 'react';

const NOOP_STATE = { status: null, runId: null, error: null, isConnected: false };

export function useStatusStream(_targetId) {
  const [state] = useState(NOOP_STATE);
  useEffect(() => {
    // intentionally empty — live stream wires up here when the real hook lands
  }, [_targetId]);
  return state;
}

export default useStatusStream;
